import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { Search, Refresh, DocumentChecked, DocumentRemove } from "@element-plus/icons-vue";
import { getEventSchedule, getEventScheduleUser, submitUserJoinCompMaterials, getBookLeaderFormUrl, batchBack, getDataFormUrl, backUserJoinCompMaterials } from "@/api/event";
import { getEventUserAwardInfoByLeader } from "@/api/user";
import { clearToken } from "@/utils/token";
import { handleSSOLogin } from "@/utils/sso-login";
export default {
  data() {
    return {
      tableData: [],
      emptyText: "暂未检索到信息",
      total: 0,
      queryParams: {
        eventId: this.$route.query.eventId,
        scheduleId: "",
        pageNum: 1,
        pageSize: 10,
        realName: "",
        mobile: ""
      },
      activeTab: {},
      eventId: this.$route.query.eventId,
      selectionList: [],
      tableData1: [],
      total1: 0,
      queryParams1: {
        eventId: this.$route.query.eventId,
        scheduleId: "",
        pageNum: 1,
        pageSize: 10,
        realName: "",
        mobile: ""
      },
      loading: false,
      url: process.env.VUE_APP_FILE_URL,
      dialogTitle: "",
      dialogVisible: false,
      dialogUrl: ""
    };
  },
  components: {
    Search,
    Refresh,
    DocumentChecked,
    DocumentRemove
  },
  created() {
    this.getEventSchedule();
  },
  methods: {
    async getEventSchedule() {
      let res = await getEventSchedule(this.eventId, 1);
      if (res.code == 200) {
        var _res$data$scheduleLis, _res$data;
        this.eventSchedule = (_res$data$scheduleLis = (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.scheduleList) !== null && _res$data$scheduleLis !== void 0 ? _res$data$scheduleLis : [];
        this.eventSchedule.push({
          id: 0,
          scheduleName: "电子证书查看"
        });
        this.activeTab = this.eventSchedule.length > 0 ? this.eventSchedule[0] : {};
        this.queryParams.scheduleId = this.activeTab.id;
        this.getEventScheduleUser();
      }
    },
    handleDetail(row) {
      getDataFormUrl({
        eventId: this.eventId,
        scheduleId: this.activeTab.id,
        userId: row.userId
      }).then(res => {
        if (res.code == 200) {
          this.dialogTitle = "查看表单";
          this.dialogUrl = res.data;
          this.dialogVisible = true;
        }
      });
    },
    handleSizeChange(size) {
      this.queryParams.pageSize = size;
      this.getEventScheduleUser();
    },
    handleCurrentChange(page) {
      this.queryParams.pageNum = page;
      this.getEventScheduleUser();
    },
    handleSearch() {
      this.queryParams.pageNum = 1;
      this.getEventScheduleUser();
    },
    handleReset() {
      this.queryParams.realName = "";
      this.queryParams.mobile = "";
      this.queryParams.pageNum = 1;
      this.getEventScheduleUser();
    },
    onChangeTab(tab) {
      this.activeTab = tab;
      this.queryParams.scheduleId = tab.id;
      this.queryParams.pageNum = 1;
      this.getEventScheduleUser();
    },
    async getEventScheduleUser() {
      this.loading = true;
      if (this.activeTab.id == 0) {
        this.queryParams.scheduleId = undefined;
        let res = await getEventUserAwardInfoByLeader(this.queryParams);
        if (res.code == 200) {
          var _res$rows, _res$total;
          this.tableData1 = (_res$rows = res === null || res === void 0 ? void 0 : res.rows) !== null && _res$rows !== void 0 ? _res$rows : [];
          this.total1 = (_res$total = res === null || res === void 0 ? void 0 : res.total) !== null && _res$total !== void 0 ? _res$total : 0;
        } else if (res.code == 401) {
          clearToken();
          handleSSOLogin();
        }
      } else {
        this.queryParams.scheduleId = this.activeTab.id;
        let res = await getEventScheduleUser(this.queryParams);
        if (res.code == 200) {
          var _res$rows2, _res$total2;
          this.tableData = (_res$rows2 = res === null || res === void 0 ? void 0 : res.rows) !== null && _res$rows2 !== void 0 ? _res$rows2 : [];
          this.total = (_res$total2 = res === null || res === void 0 ? void 0 : res.total) !== null && _res$total2 !== void 0 ? _res$total2 : 0;
        } else if (res.code == 401) {
          clearToken();
          handleSSOLogin();
        }
      }
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
      this.loading = false;
    },
    handleSubmit(row) {
      this.$confirm("确定提交资料吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        const params = {
          eventId: this.eventId,
          scheduleId: this.activeTab.id,
          ids: [row.id]
        };
        let res = await submitUserJoinCompMaterials(params);
        if (res.code == 200) {
          this.$message.success("提交成功");
          this.getEventScheduleUser();
        }
      });
    },
    handleBack(row) {
      this.$confirm("确定撤回资料吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        //row.frontTeaStatus == 1 领队未提交 直接退回到教师哪里
        if (row.frontTeaStatus === 1) {
          const params = {
            eventId: this.eventId,
            scheduleId: this.activeTab.id,
            ids: [row.id]
          };
          let res = await backUserJoinCompMaterials(params);
          if (res.code == 200) {
            this.$message.success("撤回资料成功");
            this.getEventScheduleUser();
          }
        } else {
          //row.frontTeaStatus == 2  领队已经提交 需要从后台撤回
          const params = {
            eventId: this.eventId,
            scheduleId: this.activeTab.id,
            ids: [row.id]
          };
          let res = await batchBack(params);
          if (res.code == 200) {
            this.$message.success("撤回资料成功");
            this.getEventScheduleUser();
          }
        }
      });
    },
    handleSelectionChange(selection) {
      this.selectionList = selection;
    },
    handleBatchSubmit() {
      if (this.selectionList.length == 0) {
        this.$message.warning("请选择要提交的资料");
        return;
      }
      if (this.selectionList.length > 5) {
        this.$message.warning("同一机构下，最多支持提交5份资料");
        return;
      }
      this.$confirm("确定批量提交资料吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        const params = {
          eventId: this.eventId,
          scheduleId: this.activeTab.id,
          ids: this.selectionList.map(item => item.id)
        };
        let res = await submitUserJoinCompMaterials(params);
        if (res.code == 200) {
          this.$message.success("提交成功");
          this.getEventScheduleUser();
        }
      });
    },
    handleBatchBack() {
      if (this.selectionList.length == 0) {
        this.$message.warning("请选择要撤回的资料");
        return;
      }
      let frontTeaStatus = null;
      for (let i = 0; i < this.selectionList.length; i++) {
        if (frontTeaStatus === null) {
          frontTeaStatus = this.selectionList[i].frontTeaStatus;
        } else {
          if (frontTeaStatus != this.selectionList[i].frontTeaStatus) {
            this.$message.warning("请选择提交状态一致的数据批量操作");
            return;
          }
        }
      }
      this.$confirm("确定批量撤回资料吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        //frontTeaStatus == 1 领队未提交 直接退回到教师哪里
        if (frontTeaStatus === 1) {
          const params = {
            eventId: this.eventId,
            scheduleId: this.activeTab.id,
            ids: this.selectionList.map(item => item.id)
          };
          let res = await backUserJoinCompMaterials(params);
          if (res.code == 200) {
            this.$message.success("撤回成功");
            this.getEventScheduleUser();
          }
        } else {
          //row.frontTeaStatus == 2  领队已经提交 需要从后台撤回
          const params = {
            eventId: this.eventId,
            scheduleId: this.activeTab.id,
            ids: this.selectionList.map(item => item.id)
          };
          let res = await batchBack(params);
          if (res.code == 200) {
            this.$message.success("撤回成功");
            this.getEventScheduleUser();
          }
        }
      });
    },
    async handleView(row, type) {
      let res = await getBookLeaderFormUrl({
        type: type,
        scheduleUserId: row.id
      });
      if (res.code == 200) {
        this.dialogTitle = type == "table" ? "查看报名表" : "查看资料";
        this.dialogUrl = res.data;
        this.dialogVisible = true;
      }
    },
    handleViewCertificate(row) {
      window.parent.open(this.url + row.awardImgUrl, "_blank");
    }
  }
};